export const SET_VERIFY_MOBILE_CHANGE_FORM = 'SET_VERIFY_MOBILE_CHANGE_FORM';
export const SET_UUID = 'SET_UUID';
